import { AutoRedactionRule } from '@models/auto-redaction-rule.model';

export class RedactionAnnotation {
	public id: string;
	public userId: string;
	public docId: string;
	public fileId: string;
	public rank: number;
	public x: number;
	public y: number;
	public height: number;
	public width: number;
	public text: string;
	public highlightColorId: string;
	public highlightColor: string;
	public autoRedactionRuleId?: string;
	public autoRedactionRule?: AutoRedactionRule;
}
